// console.log('Timezone (INT): ' + Intl.DateTimeFormat().resolvedOptions().timeZone);

function enableScroll() {

    const table = $('.table-responsive');

    if(table.length > 0) {
        if(table.width() < 960) {
            table.each(function() {
                new SimpleBar($(this)[0]);
            });
        }
    }

}

window.updateColor = function (current, currentPrice) {
    
    var currentClass = '';
        
    var currentText = parseFloat(current.text()),
        currentPrice = parseFloat(currentPrice);

    if(currentText > currentPrice) {
        currentClass = 'm-down';
    } else if(currentText < currentPrice) {
        currentClass = 'm-up'; 
    }

    current.addClass(currentClass);
    
    setTimeout(function () { 
        current.removeClass(currentClass);
    }, 1000);

}

window.setPnl = function () {

    var arr = [];

    $('#open .j-trade > td > span.j-pnl').each(function() {
        arr.push($(this).text().replace(',', ''));
    });

    var sum = arr.reduce((pv,cv)=>{
        return pv + (parseFloat(cv)||0);
    }, 0);

    $('.j-open_pnl').text(sum.toFixed(2));

    return sum;

}

window.setEquity = function (pnl = null) {

    if(!pnl) {
        var pnl = parseFloat($('.j-open_pnl').text());
    }

    const totalBalance = parseFloat($('.j-total_balance').text()),
        creditFunds = parseFloat($('.j-credit').text());

    var arr = [];

    $('#open .j-trade > td.j-commission').each(function() {
        arr.push($(this).text().replace(',', ''));
    });

    $('#pending .j-trade > td.j-commission').each(function() {
        arr.push($(this).text().replace(',', ''));
    });

    var commisions = arr.reduce((pv,cv)=>{
        return pv + (parseFloat(cv)||0);
    }, 0);

    $('.j-equity').text((totalBalance + creditFunds + pnl - commisions).toFixed(2));

}

function fixSidebar() {

    var sidebarEl = $('.j-sidebar');

    if(sidebarEl.length > 0 && $(window).width() >= 1200) {

        $('.j-crypto__table').height('0').css('opacity', 0);

        var content = $('.j-content').height(),
            search = sidebarEl.find('.b-search').outerHeight(),
            cryptoTit = sidebarEl.find('.crypto__tit').outerHeight(),
            margins = parseFloat(sidebarEl.find('.b-search').css('margin-bottom')) * 2,
            paddings = parseFloat(sidebarEl.find('.b-crypto').css('padding')) * 2,
            tableHeight = content - search - cryptoTit - margins - paddings;

        $('.j-crypto__table').height(tableHeight).css('opacity', 1);

    }

}

function createTradeSlider() {

    $('.j-trade_slider').each(function() {

        $('.bootstrap-growl').remove();

        var self = $(this),
            value = Number(self.attr('data-value')),
            min = Number(self.attr('data-min')),
            max = Number(self.attr('data-max'));
            step = Number(self.attr('data-step'));

        var slider = self.slider({
            create: function() {},
            slide: function(event, ui) {

                var quantity = parseFloat(ui.value);

                if(quantity > 0) {
                    $('#trade button[type="submit"]').attr('disabled', false);
                } else {
                    $('#trade button[type="submit"]').attr('disabled', true);
                }

                calc(quantity);

                $('[name="quantity"]').val(quantity);
                sliderDots(self, quantity, max);

            },
            range: 'min',
            min: min,
            max: max,
            step: step,
            value: value,
        });

    });

}

function resetTradeForm() {
    $('[name="quantity"], [name="take_profit"], [name="stop_loss"]').val('');
    $('[name="take_profit_checkbox"], [name="stop_loss_checkbox"]').prop('checked', false);
    $('.j-trade_slider').find('.label-slider').removeClass('m-active');
    calc(0);
    createTradeSlider();
}

function calc(quantity) {

    if(quantity != 0 && quantity < 0.01) {
        $.bootstrapGrowl('Min amount - 0.1', {delay: 3000});
        $('#trade button[type="submit"]').attr('disabled', true);
        return {"requiredMargin" : undefined, "budget" : undefined};
    } else {

        $('.bootstrap-growl').remove();

        var type = $('[name="type_id"]:checked').val(),
            col = 'bid';
    
        if(type == 1) {
            var col = 'ask';
        }
        
        var budget = parseFloat($('[name="free_margin"]').val()),
            leverage = parseFloat($('[name="leverage"]').val()),
            entryPrice = parseFloat($('[name="'+ col +'_price"]').val()),
            countMargin = parseFloat(((quantity * entryPrice) / leverage).toFixed(2));
            commision = parseFloat((countMargin * parseFloat($('[name="commission"]').val())  / 100).toFixed(2));
            requiredMargin = parseFloat((countMargin + commision).toFixed(2));
    
        $('.j-amount').text(quantity);
        $('.j-required_margin').text(requiredMargin);
        $('[name="used_funds"]').val(requiredMargin);
        $('.j-commision').text(commision);
    
        if(requiredMargin > budget) {
            $.bootstrapGrowl('Not enough balance on account', {delay: 3000});
            $('#trade button[type="submit"]').attr('disabled', true);
        } else {
    
            if(quantity > 0) {
                $('#trade button[type="submit"]').attr('disabled', false);
            } else {
                $('#trade button[type="submit"]').attr('disabled', true);
            }
    
        }
    
        return {"requiredMargin" : requiredMargin, "budget" : budget};

    }

}

function sliderDots(slider, total, max) {

    if(total >= max * 0.25) {
        slider.find('.label-slider:nth-child(2)').addClass('m-active');
    } 
    
    if(total >= max * 0.50) {
        slider.find('.label-slider:nth-child(3)').addClass('m-active');
    } 
    
    if(total >= max * 0.75) {
        slider.find('.label-slider:nth-child(4)').addClass('m-active');
    }

    if(total < max * 0.25) {
        slider.find('.label-slider:nth-child(2)').removeClass('m-active');
    }
    
    if(total < max * 0.50) {
        slider.find('.label-slider:nth-child(3)').removeClass('m-active');
    } 
    
    if(total < max * 0.75) {
        slider.find('.label-slider:nth-child(4)').removeClass('m-active');
    }

}

$('body').on('change', '[name="account"]', function() {

    var token = $('meta[name="csrf-token"]').attr('content'),
        data = { '_token': token, 'account_id': $(this).val() };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/changeAccount',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {
                window.location.reload();
            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl('Undefined error', {delay: 3000});
        }
    });

});

$('.j-currency_type').on('click', 'button', function() {

    var token = $('meta[name="csrf-token"]').attr('content'),
        button = $(this),
        type = button.attr('data-id'),
        data = { '_token': token, 'currency_type': type };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/changeCurrencyType',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {

                $('.j-crypto__table').html(msg['html']);

                $('.j-currency_type').children().removeClass('m-active').attr('disabled', false);
                $('.j-currency_type').children().children().attr('disabled', false);

                button.parent().addClass('m-active');
                button.attr('disabled', true);

                $('.j-currency_type').prev().text(button.text());
                $('.j-currency_type').attr('data-type', type);
                $('.j-favourite_currencies').removeClass('m-active');

            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl('Undefined error', {delay: 3000});
        }
    });

});

$('body').on('click', '.j-favourite_currencies', function() {

    var button = $(this),
        enabled = false;

    if(button.hasClass('m-active')) {
        var enabled = true;
    }

    var token = $('meta[name="csrf-token"]').attr('content'),
        type = $('.j-currency_type').attr('data-type'),
        data = { '_token': token, 'currency_type': type, 'enabled': enabled };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/favouriteCurrencies',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {
                $('.j-crypto__table').html(msg['html']);
                button.toggleClass('m-active');
            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl('Undefined error', {delay: 3000});
        }
    });

});

$('body').on('click', '.j-make_favourite', function() {

    var button = $(this),
        enabled = false;

    if(button.hasClass('m-active')) {
        var enabled = true;
    }

    var token = $('meta[name="csrf-token"]').attr('content'),
        currency = $(this).attr('data-id'),
        data = { '_token': token, 'currency': currency, 'enabled': enabled };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/makeFavourite',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {

                if(button.hasClass('m-active')) {
                    $.bootstrapGrowl('Removed from favourites', {type: 'success', delay: 3000});
                } else {
                    $.bootstrapGrowl('Added to favourites', {type: 'success', delay: 3000});
                }

                if(button.hasClass('m-active')) {
                    button.text('Add to Favourites');
                } else {
                    button.text('Remove from Favourites');
                }

                button.toggleClass('m-active');
                
            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl('Undefined error', {delay: 3000});
        }
    });

});

function loadChart(currency, type, precision, timeframe = '15') {

    $('#chartContainer').html('');

    const widget = new TradingView.widget({
        symbol: currency,
        interval: timeframe,
        container: 'chartContainer', 
        // width: '100%',
        // height: $('.j-chart').height(), 
        autosize: true,
        datafeed: Datafeed,
        library_path: '../charting_library/',



        
        // enabled_features: ["disable_resolution_rebuild"],




        disabled_features: ["header_widget", "context_menus", "timezone_menu", "symbol_info", "source_selection_markers", "timeframes_toolbar", "border_around_the_chart", "save_chart_properties_to_local_storage", "use_localstorage_for_settings", 'widget_logo', 'create_volume_indicator_by_default', 'legend_widget', "main_series_scale_menu", "show_object_tree", "show_chart_property_page"],
        theme: "dark",
        overrides: {
            'paneProperties.background': "#181B16",
            'paneProperties.backgroundType': 'solid',
        },
        loading_screen: { backgroundColor: "#181B16", foregroundColor: "#47B935" },
        custom_css_url: '/css/tradingview.css',
        timezone: $('.j-chart').attr('data-timezone'),
    });

    widget.onChartReady(() => {

        if($(window).width() <= 767) {
            widget.activeChart().executeActionById("drawingToolbarAction");
        }

        $('.j-chart').addClass('j-loaded');

        widget.activeChart().crossHairMoved().subscribe(
            null,
            function ({ entityValues }) {

                var values = entityValues._seriesId;

                if(values.isHovered) {
                    var currentBar = { 'open' : values.values[0].value, 'high' : values.values[1].value, 'low' : values.values[2].value, 'close' : values.values[3].value };
                } else {
                    var chartContainer = $('#chartContainer');
                    var currentBar = { 'open' : chartContainer.attr('data-open'), 'high' : chartContainer.attr('data-high'), 'low' : chartContainer.attr('data-low'), 'close' : chartContainer.attr('data-close') };
                }

                setTopBar(currentBar);

            }
        );

    });

    // // Create the Lightweight Chart within the container element
    // const chart = LightweightCharts.createChart(
    //     document.getElementById('chartContainer'),
    //     {
    //         width: $('.j-chart').width(),
    //         height: $('.j-chart').height(),
    //         layout: {
    //             background: { color: "#181B16" },
    //             textColor: "#DDD",
    //         },
    //         grid: {
    //             vertLines: { color: "#2b2e29" },
    //             horzLines: { color: "#2b2e29" },
    //         },
    //         // timeScale: {
    //         //     timeVisible: true,
    //         //     secondsVisible: false,
    //         // },
    //         // priceScale: {
    //         //     borderVisible: false,
    //         // },
    //         localization: {

    //             timeFormatter: businessDayOrTimestamp => {

    //                 var opt = {
    //                     timeZone: $('.j-chart').attr('data-timezone'),
    //                 };

    //                 if(type == 1) {
    //                     opt = {
    //                         year: "numeric",
    //                         month: "numeric",
    //                         day: "numeric",
    //                         hour: "numeric",
    //                         minute: "numeric",
    //                         second: "numeric",
    //                         timeZone: $('.j-chart').attr('data-timezone'),
    //                     };
    //                 } else {
    //                     var businessDayOrTimestamp = Date.parse(businessDayOrTimestamp)
    //                 }

    //                 return new Intl.DateTimeFormat('en-US', opt).format(businessDayOrTimestamp);

    //             },
    //         },
    //     }
    // );

    // // Customizing the Crosshair
    // chart.applyOptions({
    //     crosshair: {
    //         // Change mode from default 'magnet' to 'normal'.
    //         // Allows the crosshair to move freely without snapping to datapoints
    //         mode: LightweightCharts.CrosshairMode.Normal,

    //         // Vertical crosshair line (showing Date in Label)
    //         vertLine: {
    //             labelBackgroundColor: "#737D6C",
    //         },

    //         // Horizontal crosshair line (showing Price in Label)
    //         horzLine: {
    //             labelBackgroundColor: "#737D6C",
    //         },
    //     },
    //     timeScale: {
    //         // Adds hours and minutes to the chart.
    //         timeVisible: true,
    //         secondsVisible: false
    //     }
    // });

    // // Setting the border color for the vertical axis
    // chart.priceScale().applyOptions({
    //     borderColor: "#2b2e29",
    // });

    // // Setting the border color for the horizontal axis
    // chart.timeScale().applyOptions({
    //     borderColor: "#2b2e29",
    // });

    // // Create the Main Series (Candlesticks)
    // mainSeries = chart.addCandlestickSeries();
    // // Set the data for the Main Series
    // mainSeries.setData(bars);

    // // Changing the Candlestick colors
    // mainSeries.applyOptions({
    //     wickUpColor: "#47B935",
    //     upColor: "#47B935",
    //     wickDownColor: "#FF4838",
    //     downColor: "#FF4838",
    //     borderVisible: false,
    // });

    // mainSeries.applyOptions({
    //     priceFormat: {
    //         type: 'price',
    //         precision: precision,
    //         minMove: 1 / String(1).padEnd(precision + 1, '0'),
    
    //     },
    // });

    // var lastBar = bars[bars.length-1],
    //     chartContainer = $('#chartContainer');

    // chartContainer.attr({ 'data-time' : lastBar['time'], 'data-open' : lastBar['open'], 'data-high' : lastBar['high'], 'data-low' : lastBar['low'], 'data-close' : lastBar['close'] });

    // setTopBar({ 'open' : lastBar['open'], 'high' : lastBar['high'], 'low' : lastBar['low'], 'close' : lastBar['close'] });

    // chart.subscribeCrosshairMove(function(param) {

    //     if (param['seriesData'].size == 0) {
    //         var currentBar = { 'open' : chartContainer.attr('data-open'), 'high' : chartContainer.attr('data-high'), 'low' : chartContainer.attr('data-low'), 'close' : chartContainer.attr('data-close') };
    //     } else {
    //         var currentBar = Array.from(param['seriesData'])[0][1];
    //     }

    //     setTopBar(currentBar);
    
    // });

}

function updateTradeForm(freeMargin) {

    var form = $('#trade');

    form.find('[name="free_margin"]').val(freeMargin);
    form.find('.j-free_margin').text(freeMargin);

    commision = parseFloat(freeMargin) * parseFloat(form.find('[name="commission"]').val()) / 100
    maxQuantity = ((parseFloat(freeMargin) - commision) * parseFloat(form.find('[name="leverage"]').val())) / parseFloat(form.find('[name="bid_price"]').val());

    $('.j-trade_slider').attr('data-max', maxQuantity);

    createTradeSlider();

}

window.getAccount = function getAccount() {

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: 'POST',
        url: '/getAccount',
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {

                $('.j-p_total_balance').html('$ <span class="j-total_balance">'+ msg['totalBalance'] +'</span>');
                $('.j-p_credit').html('$ <span class="j-credit">'+ msg['creditFunds'] +'</span>');
                $('.j-p_free_margin').html('$ <span class="j-free_margin">'+ msg['freeMargin'] +'</span>');
                $('.j-p_used_funds').html('$ <span class="j-used_funds">'+ msg['usedFunds'] +'</span>');
                $('.j-p_equity').html('$ <span class="j-equity">'+ msg['equity'] +'</span>');
                $('.j-p_open_pnl').html('$ <span class="j-open_pnl">'+ msg['openPnl'] +'</span>');

                updateTradeForm(msg['freeMargin']);

            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl('Undefined error', {delay: 3000});
        }
    });

}

window.openCurrency = function openCurrency(currency, timeframe = '15', updateForm = true) {

    $('.j-chart').removeClass('j-loaded');

    var token = $('meta[name="csrf-token"]').attr('content'),
        data = { '_token': token, 'currency': currency, 'timeframe': timeframe, 'updateForm': updateForm };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/openCurrency',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {

                $('.j-content').attr({ 'data-currency' : msg['currency'], 'data-precision' : msg['precision'], 'data-oldprice' : msg['oldprice'] });
                $('.j-currency_top').html(msg['currencyHTML']);
                $('[name="search"]').val('');
                $('[name="search"]').next().removeClass('m-active');
                $('.j-timeframes').attr('data-defaulttimeframe', timeframe);
                $('.j-timeframes').find('.j-open_currency').attr('data-id', msg['currency_id']);
                $('.j-crypto__table').find('.j-open_currency[data-id='+ msg['currency_id'] +'] .j-current_price').text($('.j-currency_top .j-current_price').text());
                
                loadChart(msg['currency_name'], msg['type'], msg['precision'], timeframe);

                if(updateForm == true) {
                    $('#trade').html(msg['tradeHTML']);
                    updateTradeForm($('#top .j-free_margin').text());
                }

            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl('Undefined error', {delay: 3000});
        }
    });

}

$('body').on('click', '.j-open_currency', function() {

    $('.j-chart').removeClass('j-loaded');

    var button = $(this),
        currency = button.attr('data-id'),
        timeframe = $('.j-timeframes').attr('data-defaultTimeframe');

    if (typeof button.attr('data-timeframe') !== 'undefined') {
        timeframe = button.attr('data-timeframe');
    }

    if(button.hasClass('m-timeframe')) {
        button.parent().children().attr("disabled", false);
        button.attr("disabled", true);
    }

    openCurrency(currency, timeframe);

});

$('body').on('keyup', '[name="search"]', function() {

    var token = $('meta[name="csrf-token"]').attr('content'),
        search = $(this).val(),
        dropdown = $(this).next(),
        data = { '_token': token, 'search': search };
       
    if(!search) {
        dropdown.removeClass('m-active');
    } else {

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': token
            },
            type: 'POST',
            url: '/search',
            data: data,
            dataType: 'json',
            success: function( msg ) {
    
                if(msg['success'] == true) {

                    if (!dropdown.hasClass('m-active')){
                        dropdown.addClass('m-active');
                    }
    
                    if(msg['count'] == 0) {
                        dropdown.html('<span>No results</span>');
                    } else {
                        dropdown.html(msg['html']);
                    }
    
                } else {
                    $.bootstrapGrowl(msg['message'], {delay: 3000});
                }
    
            },
            error: function(data) {
                $.bootstrapGrowl('Undefined error', {delay: 3000});
            }
        });

    }

});

window.loadTrades = function loadTrades(id) {

    var block = $('#' + id),
        account = block.attr('data-account'),
        status = block.attr('data-status'),
        data = { 'account': account, 'status': status };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        type: 'POST',
        url: '/loadTrades',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {

                $('body > .dropdown-menu').remove();
                block.html(msg['html']);

                fixSidebar()

            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            var errors = data.responseJSON;
            console.log(errors);
        }
    });

}

window.updateOpenPnl = function updateOpenPnl() {

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: 'POST',
        url: '/updateOpenPnl',
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {
                console.log(msg);
            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl('Undefined error', {delay: 3000});
        }
    });

}

function loadMore(id) {

    var element = $('#' + id + ' .j-load_more');

    if(element.length > 0 && element.is(":visible") && loading == false) {

        var hT = element.offset().top,
            hH = element.outerHeight(),
            wH = $('#page_scroll').height(),
            wS = $(this).scrollTop();

        if (wS > (hT+hH-wH)) {

            loading = true;

            setTimeout(function() {

                var block = element.parent().find('table'),
                    token = $('meta[name="csrf-token"]').attr('content'),
                    page = element.attr('data-page'),
                    account = element.attr('data-account'),
                    status = element.attr('data-status'),
                    data = { '_token': token, 'page': page, 'account': account, 'status': status };

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
                    },
                    type: 'POST',
                    url: '/loadMore',
                    data: data,
                    dataType: 'json',
                    success: function( msg ) {

                        if(msg['success'] == true) {

                            loading = false;
                            block.append(msg['html']);
                            
                            if(msg['hide'] == true) {
                                element.remove();
                            } else {
                                element.attr('data-page', parseInt(page) + 1);
                            }

                            fixSidebar()

                        } else {
                            $.bootstrapGrowl(msg['message'], {delay: 3000});
                        }

                    },
                    error: function(data) {
                        var errors = data.responseJSON;
                        console.log(errors);
                    }
                });

            }, 1000);

        }

    }

}

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign +
        (j ? i.substr(0, j) + thousands : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
}

/******** validate fields ********/

function validation(id, usingClass = false) {

    var current = '#' + id + ' button[type="submit"]';

    if(usingClass == true) {
        current = '.j-' + id + ' button[type="submit"]';
    }

    $('body').on('click', current, function(e) {

        e.preventDefault();

        $('.bootstrap-growl').remove();

        var button = $(this),
            form = $(this).closest('form'),
            token = $('meta[name="csrf-token"]').attr('content'),
            data = new FormData(form.get(0));

        form.find('input').removeClass('m-error');
        data.append('_token', token);

        if($(this).attr('data-fields') == 'dob' || $(this).attr('data-fields') == 'password') {
            data.append('fields', $(this).attr('data-fields'));
        }

        button.attr("disabled", true).addClass('m-loading');

        $.ajax({
            type: "POST",
            url: '/' + id + 'Validation',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            success: function( msg ) {

                if(id != 'login') {
                    button.attr("disabled", false).removeClass('m-loading');
                }
                
                if(msg['success'] == true) {

                    if(id == 'trade') {

                        $('#open table tfoot').remove();
                        $('#open table tr:first').after(msg['html']);

                        resetTradeForm();
                        
                        $('[name="free_margin"]').val(msg['free_margin']);

                        $('.j-free_margin').text(msg['free_margin']);
                        $('.j-used_funds').text(msg['used_funds']);

                        setEquity();

                        $.bootstrapGrowl(msg['message'], {type: 'success', delay: 3000});

                    } else if(id == 'setTakeProfit' || id == 'setStopLoss') {

                        var oldOrder = $('tr[data-id="'+ data.get('trade_id') +'"]');

                        if(id == 'setTakeProfit') {
                            oldOrder.find('.j-take_profit button').dropdown('toggle');
                        } else {
                            oldOrder.find('.j-stop_loss button').dropdown('toggle');
                        }

                        oldOrder.after(msg['html']);
                        oldOrder.remove();

                        $.bootstrapGrowl(msg['message'], {type: 'success', delay: 3000});

                    } else if(id == 'closeOrder' || id == 'cancelOrder') {

                        var oldOrder = $('tr[data-id="'+ data.get('trade_id') +'"]');
                            
                        oldOrder.find('.j-close_button').dropdown('toggle');

                        if(msg['partial']) {
                            oldOrder.after(msg['html']);
                            $('#history table tr:first').after(msg['partial']);
                        } else {
                            $('#history table tr:first').after(msg['html']);
                        }

                        $('#history table tfoot').remove();

                        oldOrder.remove();

                        var tab = 'open';

                        if(id == 'cancelOrder') {
                            var tab = 'pending';
                        }

                        if($('#'+ tab +' table tr').length <= 1) {
                            $('#'+ tab +' table').append('<tfoot><tr><td colspan="100%">No orders</td></tr></tfoot>');
                        }

                        $('[name="free_margin"]').val(msg['free_margin']);

                        $('.j-total_balance').text(msg['total_balance']);
                        $('.j-free_margin').text(msg['free_margin']);
                        $('.j-used_funds').text(msg['used_funds']);

                        if(id == 'closeOrder') {

                            var sum = 0;

                            if($('#open .j-trade').length > 0) {
                                sum = setPnl();
                            } else {
                                $('.j-open_pnl').text('0.00');
                            }

                            setEquity(sum);

                        }

                        $.bootstrapGrowl(msg['message'], {type: 'success', delay: 3000});

                    } else {

                        if(msg['redirect']) {
                            window.location.replace(msg['redirect']);
                        } else {
                            //
                        }

                    }

                } else {

                    button.attr("disabled", false).removeClass('m-loading');

                    if(msg['errors'] == undefined) {
                        $.bootstrapGrowl(msg['message'], {delay: 3000});
                    } else {
                        var errors = '';
                        $.each(msg['errors'], function(index, values) {

                            var element = form.find('[name=' + index + ']');

                            if(element.is('select')) {
                                element.next().addClass('m-error');
                            } else if(element.is('input[type="radio"]')) {
                                element.parent().addClass('m-error');
                            } else {
                                element.addClass('m-error');
                            }

                            $.each(values, function(index, value) {
                                errors = errors + value + '<br>';
                            });
                        });

                        $.bootstrapGrowl(errors, {delay: 30000});
                    }

                }
                
            },
            error: function(data) {
                button.attr("disabled", false).removeClass('m-loading');
                $.bootstrapGrowl('Undefined error', {delay: 3000});
           }
        });

    });

}

////////

$(window).on('resize', function() {
    fixSidebar();
    enableScroll();
});

$(document).ready(function() {

    validation('login');
    validation('trade');
    validation('setTakeProfit', true);
    validation('setStopLoss', true);
    validation('closeOrder', true);
    validation('cancelOrder', true);

    createTradeSlider();
    enableScroll();

    $('body').on('show.bs.dropdown', 'table .btn-group', function() {

        var oldDropdown = $('body').children('.dropdown-menu');

        if(oldDropdown.length > 0) {
            $('table .btn-group[data-dropdown_id="'+ oldDropdown.attr('data-dropdown_id') +'"]').children('button').click();
        }

        var dropdown = $(this).find('.dropdown-menu');

        $('body').append(dropdown.css({
          position: 'absolute',
          left: dropdown.offset().left,
          top: dropdown.offset().top
        }).detach());

    });

    $('body').on('hidden.bs.dropdown', 'table .btn-group', function() {

        $(this).append($('body').children('.dropdown-menu').css({
          position: false,
          left: false,
          top: false
        }).detach());

    });

    $('body').on('click', '.j-close_dropdown', function() {

        var dropdown = $(this).parent().parent(),
            group = $('table .btn-group[data-dropdown_id="'+ dropdown.attr('data-dropdown_id') +'"]');

        group.children('button').click();

    });

    $('body').on('click', '.j-pass_action', function(e) {
        if($(this).hasClass('m-active')) {
            $(this).removeClass('m-active');
            $(this).prev().prop('type', 'password');
        } else {
            $(this).addClass('m-active');
            $(this).prev().prop('type', 'text');
        }
    });

    $('body').on('click', 'button[data-dismiss="alert"]', function(e) {
        $(this).parent().remove();
    });

    if($('#crypto_table').length > 0) {
        new SimpleBar($('#crypto_table')[0]);
    }

    if($('#page_scroll').length > 0) {
        var simpleBar = new SimpleBar($('#page_scroll')[0]);
        simpleBar.getScrollElement().addEventListener('scroll', scrollHandler, { passive: true });
    }

    loading = false;

    function scrollHandler (event) {
        loadMore('open');
        loadMore('pending');
        loadMore('history');
    }

    $('#trades [data-bs-toggle="tab"]').on('shown.bs.tab', function () {
        fixSidebar();
    });

    if(!$('#content').hasClass('m-page')) {
        fixSidebar();
    }

    $('input').bind('focus',function() {
        $(this).removeClass('m-error');
    });

    $('select').select2();

    $('body').on('keyup', '.j-only_numbers', function() {
        this.value = this.value.replace(/[^0-9\.]/g,'');
    });

    $('body').on('change', '.j-split input[type="checkbox"]', function() {

        const input = $(this).parent().next().find('input[type="text"]');

        input.prop('disabled', (i, v) => !v);

        if($(this).is(":checked")) {
            input.focus();
        } else {
            input.val('');
        }

    });

    $('body').on('input', '.j-type_switch', function(e) {

        $('.j-partial').toggleClass('d-none');

        var form = $(this).closest('form');

        if($(this).val() == 0) {
            form.find('.j-pnl').removeClass('j-manual').text(form.find('[name="pnl_all"]').val());
            form.find('[name="amount"]').val('0');
            form.find('.j-amount').text('0');
            form.find('.j-close_trade_slider').slider('value', 0);
            $('.j-close_trade_slider').find('.label-slider').removeClass('m-active');
        } else if($(this).val() == 1) {
            form.find('.j-pnl').addClass('j-manual').text(0);
        }
    
    });

    $('.j-close_trade_slider').each(function() {

        var self = $(this),
            form = $(this).closest('form'),
            value = Number(self.attr('data-value')),
            min = Number(self.attr('data-min')),
            max = Number(self.attr('data-max'));
            step = Number(self.attr('data-step'));

        var slider = self.slider({
            create: function() {},
            slide: function(event, ui) {

                var percent = ui.value,
                    pnlAll = form.find('[name="pnl_all"]').val(),
                    quantity = self.attr('data-quantity');

                form.find('.j-pnl').text((pnlAll * (percent / 100)).toFixed(2));
                form.find('.j-amount').text((quantity * (percent / 100)).toFixed(2));
                form.find('[name="amount"]').val((quantity * (percent / 100)).toFixed(2));
                
                sliderDots(self, percent, max);

            },
            range: 'min',
            min: min,
            max: max,
            step: step,
            value: value,
        });
        
    });

    $('body').on('change', '[name="type_id"]', function(e) {

        var type = $('[name="type_id"]:checked').val(),
            col = 'bid';
            typeWord = 'Buy';

        if(type == 1) {
            var col = 'ask',
                typeWord = 'Sell';
        }

        $('.j-type_word').text(typeWord);

        budget = parseFloat($('[name="free_margin"]').val()),
        entryPrice = parseFloat($('[name="'+ col +'_price"]').val()),
        commision = budget * parseFloat($('[name="commission"]').val()) / 100;
        maxQuantity = parseFloat(((budget - commision) * $('[name="leverage"]').val()) / entryPrice);

        $('.j-trade_slider').attr('data-max', maxQuantity);

        resetTradeForm();

    });

    $('body').on('keyup', '[name="quantity"]', function() {

        $('.bootstrap-growl').remove();
        
        var quantity = parseFloat($('[name="quantity"]').val());

        if(isNaN(quantity)) {
            quantity = 0;
            $('#trade button[type="submit"]').attr('disabled', true);
        }

        var data = calc(quantity);

        sliderDots($('.j-trade_slider'), data['requiredMargin'], data['budget']);
        $('.j-trade_slider').slider('value', quantity);

    });

    $('body').on('keyup', '.j-setTakeProfit [name="price"], .j-setStopLoss [name="price"]', function() {

        $('.bootstrap-growl').remove();

        var price = $(this).val(),
            form = $(this).closest('form'),
            entryPrice = form.find('[name="entry_price"]').val(),
            type = form.find('[name="type_id"]').val(),
            quantity = form.find('[name="quantity"]').val(),
            pnl = ((price * quantity) - (entryPrice * quantity)).toFixed(2);
            
        if(type == 1) {
            pnl = ((entryPrice * quantity) - (price * quantity)).toFixed(2);
        }

        if(form.hasClass('j-setTakeProfit') && pnl < 0) {

            if(type == 0) {
                $.bootstrapGrowl('Take Profit cannot be less then Entry Price', {delay: 3000});
            } else {
                $.bootstrapGrowl('Take Profit cannot be more then Entry Price', {delay: 3000});
            }

            form.find('.j-potential').text('0');
            $(this).addClass('m-error');
            
        } else if(form.hasClass('j-setStopLoss') && pnl > 0) {

            if(type == 0) {
                $.bootstrapGrowl('Stop Loss cannot be more then Entry Price', {delay: 3000});
            } else {
                $.bootstrapGrowl('Stop Loss cannot be less then Entry Price', {delay: 3000});
            }

            form.find('.j-potential').text('0');
            $(this).addClass('m-error');

        } else {
            form.find('.j-potential').text(pnl);
            $(this).removeClass('m-error');
            $('.bootstrap-growl').remove();
        }

    });

    if($('.j-timezone').length > 0) {
        $('.j-timezone').val(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }

    if($('.j-chart').attr('data-timezone') == '') {
        $('.j-chart').attr('data-timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
    }

    $('body').on('click', '.j-remove_stop', function() {

        var button = $(this),
            token = $('meta[name="csrf-token"]').attr('content'),
            trade = $(this).parent().parent().find('[name="trade_id"]').val(),
            type = $(this).attr('data-type');
            data = { '_token': token, 'trade_id': trade, 'type': type };

        button.attr("disabled", true).addClass('m-loading');
    
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': token
            },
            type: 'POST',
            url: '/removeStop',
            data: data,
            dataType: 'json',
            success: function( msg ) {

                button.attr("disabled", false).removeClass('m-loading');
    
                if(msg['success'] == true) {

                    var oldOrder = $('tr[data-id="'+ trade +'"]');

                    if(type == 'profit') {
                        oldOrder.find('.j-take_profit button').dropdown('toggle');
                    } else {
                        oldOrder.find('.j-stop_loss button').dropdown('toggle');
                    }

                    oldOrder.after(msg['html']);
                    oldOrder.remove();

                    $.bootstrapGrowl(msg['message'], {type: 'success', delay: 3000});

                } else {
                    $.bootstrapGrowl(msg['message'], {delay: 3000});
                }
    
            },
            error: function(data) {
                button.attr("disabled", false).removeClass('m-loading');
                $.bootstrapGrowl('Undefined error', {delay: 3000});
            }
        });
    
    });

});